import { useState } from "react";

export const useModal = () => {
    const [show, setShow] = useState(false);

    const closeModal = () => {
        setShow(false);
    };
   
    const showModal = () => {
        setShow(true);
    };

    return [show, showModal, closeModal];
};
